import React from 'react'
import PropTypes from 'prop-types'
import { Dropdown, Link } from 'atoms'
import Bell from 'images/icons/Bell'
import styled from 'styled-components'
import { media } from 'tools/browser'
import { query } from 'tools/fetch'
import { getNotificationDetails } from 'tools/notifications'
import { settings } from 'contexts/settings-context'
import NotificationsTray from './NotificationsTray'

const BellWrapper = styled(Link)`
    padding: 8px;
    display: inline-flex;
    position: relative;

    ${media.greaterThan.large`
        padding: 16px;

        &:after {
            bottom: 16px !important;
            left: 16px !important;
        }
    `}

    &:after {
        content: '';
        color: #FFF;
        font-size: 8px;
        line-height: 12px;
        width: 12px;
        height: 12px;
        border-radius: 50%;
        position: absolute;
        bottom: 8px;
        left: 8px;
        background: #F00;
        border: 1px solid white;
        text-align: center;
        display:none;
        box-shadow: 2px 0 8px 0 rgba(0,0,0,0.4);
    }

    ${props => props.unreadCount > 0 && `
        &:after {
            display: inline;
            content: '${props.unreadCount}';
        }
    `}
`

const NOTIFICATIONS_QUERY = `
  {
    notifications {
        uuid
        readAt
        intendedClients
        publishedAt
        message {
            brand
            payload
            url
        }
    }
  }
`

const MARK_READ_MUTATION = `
  mutation NotificationsBell ($notifications: [UUID]!) {
    markHeaderNotificationsRead(notifications: $notifications) {
      readAt
    }
  }
`

class NotificationsBell extends React.Component {
  state = {
    notifications: null,
    notificationDetails: null,
  }

  componentDidMount () {
    this.getNotifications()
  }

  async getNotifications () {
    const { accessToken } = this.props
    if (accessToken === undefined) {
      // eslint-disable-next-line no-console
      console.error('Provided access token is undefined')
    }
    const queryDetails = {
      uri: settings.CONNECT_API_URI,
      accessToken: accessToken,
      query: NOTIFICATIONS_QUERY,
    }

    const data = await query(queryDetails)
    if (data) {
      this.setState({ notifications: data.notifications })
    } else {
      this.setState({ notifications: [] })
    }
  }

  async markNotificationsRead () {
    const { accessToken } = this.props
    const { notificationDetails } = this.state

    const unreadNotificationIds = notificationDetails.notifications.reduce((accumulator, notification) => {
      if (!notification.readAt) {
        accumulator.push(notification.uuid)
      }
      return accumulator
    }, [])

    const queryDetails = {
      uri: settings.CONNECT_API_URI,
      query: MARK_READ_MUTATION,
      accessToken: accessToken,
      variables: { notifications: unreadNotificationIds },
    }

    const data = await query(queryDetails)
    if (data) {
      this.setState(Object.assign(notificationDetails, { unreadCount: 0 }))
    }
  }

  componentDidUpdate () {
    const { notifications, notificationDetails } = this.state
    const { activatedClients } = this.props
    if (notifications && !notificationDetails) {
      const notificationDetails = getNotificationDetails(notifications, activatedClients)
      this.setState({ notificationDetails: notificationDetails })
    }
  }

  render () {
    const { notificationDetails } = this.state

    const details = notificationDetails || {
      unreadCount: 0,
      notifications: [],
    }

    return (
      <Dropdown
        label={
          <BellWrapper id="shgn-notifications-bell" data-unread-count={details.unreadCount} unreadCount={details.unreadCount} href="#">
            <Bell />
          </BellWrapper>
        }
        onOpen={
          () => {
            try {
              this.markNotificationsRead()
            } catch (ex) {
              // do nothing here.  User likely has 3rd-party cookies/data disabled
            }
          }
        }
      >
        <NotificationsTray notifications={details.notifications} />
      </Dropdown>
    )
  }
}

NotificationsBell.propTypes = {
  accessToken: PropTypes.string.isRequired,
  activatedClients: PropTypes.array.isRequired,
}

export default NotificationsBell



// WEBPACK FOOTER //
// ./src/molecules/NotificationsBell/NotificationsBell.js